module.exports = __webpack_public_path__ + "static/logo-with-text1-a619c6d76511c1dfa5af21c645219f07.png";